import * as types from './mutation-types'
const mutations = {
  // 获取系统信息
  [types.SET_SYSTEM_INFO](state, data) {
    state.systemInfo = data
  },
  // 账号信息
  [types.SET_ACCOUNT_INFO](state, data) {
    state.accountInfo = data
  },
  [types.SET_ADMIN_ACCESS](state, data) {
    state.isAdmin = data
  },
  [types.SET_NEW_USER](state, data) {
    state.isNewUser = data
  },
  [types.SET_CREATE_STEP](state, data) {
    state.createStep = data
  },

  // libInfo
  [types.SET_LIB_INFO](state, data) {
    state.libInfo = data
  },
  [types.SET_LIB_LIST](state, data) {
    state.libList = data
  },

  // publicationInfo
  [types.SET_PUBLICATION_INFO](state, data) {
    state.publicationInfo = data
  },
  [types.SET_MAGAZINE_LIST](state, data) {
    state.magazineList = data
  },

  // magazine
  /**
   * 更新 magazine config
   * @param state {object}
   * @param data {object}
   */
  [types.SET_MAGAZINE_CONFIG](state, data) {
    state.magazineConfig = data
  },
  [types.SET_MAGAZINE_INFO](state, data) {
    state.magazineInfo = data
  },
  setNotIncludedProviders(state, data) {
    state.notIncludedProviders = data
  },
  setColumnKindList(state, data) {
    state.columnKindList = data
  },
}

export default mutations
